import React from 'react';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; 
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import "./styles/variables.css";
import store  from './redux/store';


const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(

  <Provider store={store}>

  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}> 
    <App />
    </BrowserRouter> 
  </React.StrictMode> 

  </Provider>
);

reportWebVitals();







